import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchData, postData } from '../../shared/api/api'
import { AppDispatch, RootState } from '../../app/store'
import {
  FetchZoneByIdRequest,
  FetchZoneByIdResponse,
  SetActiveZoneRequest,
  SetActiveZoneResponse,
} from './types'
import { BriefZone, CaseZone, ZoneTypeEnum } from '../../shared/types'
import { fetchActiveDossier } from '../dossier/dossierThunks'

export const fetchZoneById = createAsyncThunk<
  FetchZoneByIdResponse | null,
  FetchZoneByIdRequest,
  { state: RootState }
>('zones/fetchById', async ({ zoneId }, thunkAPI) => {
  try {
    const response = await fetchData<any>(`/zones/${zoneId}`)
    const type = response?.type ? response?.type : ZoneTypeEnum.Case

    if (type === ZoneTypeEnum.Case) {
      return {
        ...response,
        type,
      } as CaseZone
    }

    if (type === ZoneTypeEnum.Brief) {
      return {
        ...response,
        type,
      } as BriefZone
    }
    return {
      ...response,
      type,
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message)
  }
})

export const setActiveZone = createAsyncThunk<
  any,
  SetActiveZoneRequest,
  { state: RootState; rejectValue: { error: string } }
>('setActiveZone/post', async (payload, thunkAPI) => {
  // return thunkAPI.rejectWithValue({ error: 'Error setting Active Zone' })
  const state = thunkAPI.getState()
  const userId = state.user?.profile?.uid
  if (!userId) {
    return thunkAPI.rejectWithValue({
      error: 'User ID not found in redux state',
    })
  }
  try {
    const response = await postData<SetActiveZoneResponse>(
      `/users/${userId}/setActiveZone`,
      payload
    )
    // TODO:
    // const type = response?.type ? response?.type : ZoneTypeEnum.Case
    // if (type === ZoneTypeEnum.Case) {
    //   return {
    //     ...response,
    //     type,
    //   } as CaseZone
    // }
    // if (type === ZoneTypeEnum.Brief) {
    //   return {
    //     ...response,
    //     type,
    //   } as BriefZone
    // }
    // return {
    //   ...response,
    //   type,
    // }

    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.error ||
        error?.response?.data ||
        error?.message || { error: 'Error setting Active Zone' }
    )
  }
})

export const hydrateZoneFromUserDossier = createAsyncThunk<
  { dossierId?: string },
  void,
  { dispatch: AppDispatch }
>('app/hydrateFromUserContext', async (_, { dispatch }) => {
  const dossier = await dispatch(fetchActiveDossier()).unwrap()

  if (dossier?.id) {
    await dispatch(
      fetchZoneById({ zoneId: dossier.id, applyToState: true })
    ).unwrap()
  }

  return { dossierId: dossier?.id }
})
